import { usercache } from '../../tools/usercache';

export const providerError = res => {
  const error = res.data || {};
  const errorMessage = error.message || '';

  if (res.status === 404 || error.errorCode === 'NotFound') {
    throw {
      ...res,
      data: {
        ...res.data,
        isSelectionError: true,
      },
    };
  }

  if (
    errorMessage.startsWith('User is unable to save provider') ||
    errorMessage.startsWith('Provider selection parsing failed')
  ) {
    throw {
      ...res,
      code: 'NOT_FOUND',
    };
  }
};

export const cacfError = res => {
  const data = res.data || {};

  if (data.statusCode !== 'SUC000') {
    if (data.statusMessage === 'Access denied') {
      throw {
        ...res,
        code: 'ACCESS_DENIED',
      };
    }

    throw {
      ...res,
      code: data.statusCode,
    };
  }

  return res;
};

export const organizationsError = res => {
  const isIntakeUser = usercache.get('isIntakeUser');
  if (isIntakeUser) {
    return res;
  }
  cacfError(res);
  const data = res.data || {};

  if ((data.privileges || []).length === 0) {
    throw {
      ...res,
      code: 'ACCESS_DENIED',
    };
  }

  return res;
};
